module.exports = __webpack_public_path__ + "img/agroindustrial.7a310449.svg";